import { postJSON } from 'common/services/api'
import {
  REVISIONS_QUERY_KEY,
  REVISIONS_PUBLISH_URL,
  REVISION_PUBLISH_QUERY_KEY,
  TODAY_MONITORING_QUERY_KEY,
  REVISION_QUERY_KEY,
  INSTANCE_QUERY_KEY,
  INSTANCES_QUERY_KEY,
} from './queryConstants'
import { useMutation, useQueryClient } from 'react-query'

type UseRevisionPublishReturn = {
  publishRevision?: () => Promise<unknown>
  isPublishRevisionLoading?: boolean
}

type UseRevisionPublishProps = {
  id?: string
}

const useRevisionPublish = ({
  id,
}: UseRevisionPublishProps): UseRevisionPublishReturn => {
  const queryClient = useQueryClient()

  // Publish event
  const publishFunction = async (): Promise<unknown> => {
    return postJSON({
      url: `${REVISIONS_PUBLISH_URL}/${id}`,
      method: 'POST',
      isRota: true,
    })
  }

  const { mutateAsync: publishMutation, isLoading: isPublishRevisionLoading } =
    useMutation<unknown>([REVISION_PUBLISH_QUERY_KEY], publishFunction, {
      onSuccess: () => {
        queryClient.invalidateQueries([REVISIONS_QUERY_KEY])
        queryClient.invalidateQueries([REVISION_QUERY_KEY, id])
        queryClient.invalidateQueries([TODAY_MONITORING_QUERY_KEY])
        queryClient.invalidateQueries([INSTANCE_QUERY_KEY])
        queryClient.invalidateQueries([INSTANCES_QUERY_KEY])
      },
    })

  const handlePublish = async () => {
    try {
      const result = await publishMutation()
      return result
    } catch (err) {
      return err
    }
  }

  return {
    publishRevision: handlePublish,
    isPublishRevisionLoading,
  }
}

export default useRevisionPublish
